import React, { useEffect, useState } from 'react'
import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    Platform,
    Pressable,
    FlatList,
} from 'react-native'
import { Feather } from '@expo/vector-icons'
import { ProductsModel } from './models/PortfolioProductsModel'
import { FlashList } from '@shopify/flash-list'
import { useNavigation } from '../../hooks/useWebNavigation'
import { ScrollView, TouchableOpacity } from 'react-native-gesture-handler'
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { ProductDetail } from './PortfolioProductDetail'
import styles from './PortfolioProductsStyles'
import theme from '../../../theme'
import { getProductsBycategoryId, getProductsByIds } from '../../db/portfolio'
import { openDB } from '../../db/indexDB'
import { placeholderGeneral } from '../customUtils/Constants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { CatalogueCategoriesModel } from './models/PortfolioModel'
import Constants from 'expo-constants'
import {
    useBreakpoint,
    useDimensionsStore,
} from '../../../src/redux/zustand/useDimensionStore'
import { Image } from 'expo-image'

const isWeb = Platform.OS === 'web'

interface Props extends StackScreenProps<DotsNavigation, 'PortfolioProducts'> {}

export const PortfolioProducts = ({ route }: Props) => {
    const { languageFile } = getLanguage()
    const { categoryId, products, item } = route.params
    const [productsList, setProducts] = useState<ProductsModel[]>([])

    const navigation = useNavigation()

    const fetchProductsDBlocal = async (categoryId) => {
        console.log(
            '🚀 ~ file: PortfolioProducts.tsx:26 ~ fetchProductsDBlocal ~ categoryId:',
            categoryId,
        )
        try {
            console.log('Entro fetchProductsDBlocal')

            if (categoryId) {
                const database = await openDB()
                const productsDB = await getProductsBycategoryId(
                    database,
                    categoryId,
                )
                console.log(
                    '[PortfolioProducts] Productos desde IndexedDB:',
                    productsDB,
                )
                setProducts(productsDB)
            }
        } catch (error) {
            console.error('fetchProductsDBlocal ERROR => ', error)
        }
    }

    useEffect(() => {
        console.log('[PortfolioProducts] route.params:', route.params)
        console.log('[PortfolioProducts] products recibidos:', products)

        const loadProducts = async () => {
            // Priorizar productos que vienen en params
            if (products && Array.isArray(products) && products.length > 0) {
                console.log(
                    '[PortfolioProducts] Usando productos de params:',
                    products.length,
                )

                // Check if products are IDs (strings) or objects
                const firstProduct = products[0]
                const areProductIds = typeof firstProduct === 'string'

                if (areProductIds && !isWeb) {
                    // Native: products are IDs, need to fetch from database
                    console.log(
                        '[PortfolioProducts] Products are IDs, fetching from database...',
                    )
                    try {
                        const database = await openDB()
                        const productObjects = await getProductsByIds(
                            database,
                            products,
                        )
                        console.log(
                            '[PortfolioProducts] Fetched product objects:',
                            productObjects.length,
                        )
                        setProducts(productObjects)
                    } catch (error) {
                        console.error(
                            '[PortfolioProducts] Error fetching products by IDs:',
                            error,
                        )
                        setProducts([])
                    }
                } else {
                    // Web: products are already objects
                    console.log(
                        '[PortfolioProducts] Products are objects, using directly',
                    )
                    setProducts(products)
                }
            } else if (categoryId) {
                // Fallback: cargar desde IndexedDB si no vienen productos en params
                console.log(
                    '[PortfolioProducts] Cargando productos desde IndexedDB para categoryId:',
                    categoryId,
                )
                fetchProductsDBlocal(categoryId)
            } else {
                console.warn('[PortfolioProducts] No hay productos ni categoryId')
                setProducts([])
            }
        }

        loadProducts()
    }, [categoryId, products])

    const goToProductDetail = (product: ProductsModel) => {
        console.log('🚀 ~ goToProductDetail ~ product:', product)

        navigation.navigate('PortfolioProductDetail', { data: product })
    }
    const bp = useBreakpoint()
    const smallWindow = bp === 'sm'
    const midWindow = bp === 'md'
    const { width } = useDimensionsStore()
    switch (productsList.length) {
        case 0: {
            return (
                <View style={styles.containerNoProducts}>
                    <Image
                        style={styles.image}
                        source={require('../../../assets/noProducts.png')}
                    />
                    <Text style={styles.title}>
                        {languageFile.no_products_to_show}
                    </Text>
                    <Text style={styles.description}>
                        {languageFile.try_again_later}
                    </Text>
                </View>
            )
        }
        case 1: {
            return <ProductDetail product={productsList[0]} />
        }

        default: {
            // Para web: usar grid de 2 columnas en pantallas grandes
            const numColumns = isWeb && !smallWindow ? (midWindow ? 2 : 3) : 1

            return (
                <View style={styles.containerBis}>
                    <ScrollView showsVerticalScrollIndicator={false}>
                        <Image
                            source={{
                                uri: item.image ? item.image : placeholderGeneral,
                            }}
                            style={[
                                styles.brand,
                                !smallWindow && {
                                    width: '100%',
                                    height: 180,
                                    marginBottom: 36,
                                },
                            ]}
                            contentFit={smallWindow ? 'cover' : 'contain'}
                            cachePolicy='memory-disk'
                        />

                        <FlatList
                            data={productsList}
                            keyExtractor={(item) => item._id}
                            horizontal={false}
                            showsVerticalScrollIndicator={false}
                            numColumns={numColumns}
                            key={`products-grid-${numColumns}`}
                            renderItem={({ item: prods }) => (
                                <ProductListItem
                                    product={prods}
                                    goToProductDetail={() =>
                                        goToProductDetail(prods)
                                    }
                                    numColumns={numColumns}
                                />
                            )}
                            {...(numColumns > 1 && {
                                columnWrapperStyle: {
                                    gap: 8, // Espacio horizontal entre columnas
                                },
                            })}
                            ItemSeparatorComponent={() => (
                                <View style={{ height: 8 }} /> // Espacio vertical entre filas
                            )}
                        />
                    </ScrollView>
                </View>
            )
        }
    }
}

const ProductListItem = ({
    product,
    goToProductDetail,
    numColumns = 1,
}: {
    product: ProductsModel
    goToProductDetail: () => void
    numColumns?: number
}) => {
    const { languageFile } = getLanguage()
    const expoConfig = Constants.expoConfig || { slug: '' }
    const getEanText = (slug: string) => {
        switch (slug) {
            case 'one-mitsubishi':
                return 'Slogan: '
            case 'one-pfizer':
                return 'Presentación: '
            default:
                return 'EAN: '
        }
    }
    const eanPrefix = getEanText(expoConfig.slug)
    const bp = useBreakpoint()
    const smallWindow = bp === 'sm'
    // Para grid en web, ajustar estilos del container
    const containerStyle =
        isWeb && numColumns > 1
            ? [styles.container, webProductStyles.gridItem]
            : styles.container
    const maxWidth = numColumns > 2 ? '33%' : '50%'

    return (
        <Pressable
            onPress={goToProductDetail}
            style={[
                styles.container,
                !smallWindow && { marginVertical: 0, maxWidth: maxWidth },
            ]}
        >
            <View style={styles.containerProductListItem}>
                {product.medias && product.medias.length > 0 && (
                    <Image
                        source={{ uri: product.medias[0].media_url }}
                        style={[styles.imageProduct, isWeb && { width: 130 }]}
                        contentFit='contain'
                        cachePolicy='memory-disk'
                    />
                )}
            </View>
            <View style={styles.containerDataProducts}>
                {product.name && (
                    <Text
                        style={[
                            styles.nameProduct,
                            !smallWindow && { fontSize: 24 },
                        ]}
                    >
                        {product.name ?? ''}
                    </Text>
                )}
                <View style={{ flexDirection: 'column' }}>
                    {product.ean && (
                        <Text
                            style={[
                                styles.dataProduct,
                                !smallWindow && { fontSize: 16, marginTop: 4 },
                            ]}
                            numberOfLines={2}
                            ellipsizeMode='tail'
                        >
                            {eanPrefix + [product.ean ?? '']}
                        </Text>
                    )}
                    {product.sku && (
                        <Text
                            style={[
                                styles.dataProduct,
                                !smallWindow && { fontSize: 16 },
                            ]}
                            numberOfLines={2}
                            ellipsizeMode='tail'
                        >
                            {(expoConfig.slug != 'one-mitsubishi'
                                ? 'SKU: '
                                : 'Precio: ') + [product.sku ?? '']}
                        </Text>
                    )}
                </View>

                <View style={styles.containerSeeMore}>
                    <Text style={styles.seeMore}>{languageFile.see_more}</Text>
                    <Feather
                        name='chevron-right'
                        size={24}
                        color={theme.colors.colorPrimary}
                    />
                </View>
            </View>
            {/* {isWeb && <Feather name='chevron-right' size={24} color={theme.colors.colorPrimary} />} */}
        </Pressable>
    )
}

// Estilos específicos para web
const webProductStyles = StyleSheet.create({
    gridItem: {
        flex: 1,
        maxWidth: '50%', // 2 columnas
        paddingHorizontal: 5,
    },
})
